import { get } from '../utils';
export var getDraft = function (state) { return state.draft; };
export var getSubmitCount = function (state) { return getDraft(state).submitCount || 0; };
export var getValue = function (path, state) { return get(getDraft(state).values, path); };
export var getTouched = function (path, state) {
    var touched = get(getDraft(state).touched, path);
    var submitCount = getSubmitCount(state);
    return touched === undefined
        ? submitCount > 0
        : touched;
};
export var getError = function (path, state) { return get(getDraft(state).errors, path); };
